"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOutOfStockQuantity = void 0;
const getOutOfStockQuantity = (param)=>{
    let { outOfStockQuantity, outOfStockProducts } = param;
    let outOfStockItemsCount = outOfStockQuantity !== null && outOfStockQuantity !== void 0 ? outOfStockQuantity : 0;
    if (outOfStockQuantity === undefined) {
        outOfStockProducts === null || outOfStockProducts === void 0 ? void 0 : outOfStockProducts.forEach((product)=>{
            outOfStockItemsCount += product.quantity;
        });
    }
    return outOfStockItemsCount;
};
exports.getOutOfStockQuantity = getOutOfStockQuantity;
